var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 11;\n  background-color: rgba(0, 0, 0, 0.54);\n  will-change: opacity;\n'], ['\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 11;\n  background-color: rgba(0, 0, 0, 0.54);\n  will-change: opacity;\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import * as React from 'react';
import { TransitionMotion, spring } from 'react-motion';
import styled from 'styled-components';
export var StyledBacktick = styled.div(_templateObject);
export var Backtick = function Backtick(_ref) {
  var open = _ref.open,
      onClick = _ref.onClick;
  return React.createElement(TransitionMotion, { willLeave: function willLeave() {
      return { opacity: spring(0) };
    }, defaultStyles: [{ key: 'backtick', style: { opacity: 0 } }], styles: open ? [{ key: 'backtick', style: { opacity: spring(1) } }] : [] }, function (interpolatedStyles) {
    return React.createElement("div", null, interpolatedStyles.map(function (config) {
      return React.createElement(StyledBacktick, { onClick: onClick, key: config.key, style: config.style });
    }));
  });
};
//# sourceMappingURL=backtick.js.map
